import {InputEventUtils} from '../../utils/input_event_utils';
import { IdealShoppingCartVariant, ShoppingCartVariant } from '../../interfaces/shopping-cart.interface';
import {ShoppingCartItems} from '../shopping-cart-items';
import {CurrencyService} from '../../api/services/currency.service';
import {ShoppingCartService} from '../../api/services/shopping-cart.service';
import {IdealCartService} from '../../api/services/ideal-cart.service';
import { CurrencyUtils } from '../../utils/currency_utils';

export abstract class ShoppingCartItemBaseComponent {
  readonly mainContainer: HTMLElement;

  protected constructor(
    protected shoppingCartItems: ShoppingCartItems,
    protected product: ShoppingCartVariant | IdealShoppingCartVariant,
    protected currencyService: CurrencyService,
    protected shoppingCartService: ShoppingCartService | IdealCartService
  ) {
    this.mainContainer = document.createElement('div');
    InputEventUtils.addSelectEvents(this.mainContainer, this.handleClicks.bind(this));
  }

  abstract changeQuantity(el: HTMLElement);

  abstract deleteItem();

  abstract updateDisableState();

  abstract renderItem();

  private handleClicks(e) {
    if (this.shoppingCartItems.processing) {
      return;
    }
    e.stopPropagation();
    const quantityEl = e.target.closest('.app-shopping-cart-item-quantity-button');
    const removeEl = e.target.closest('.app-shopping-cart-item-delete');
    const productTitle = e.target.closest('.app-shopping-cart-item-title');

    if (productTitle) {
      this.shoppingCartItems.navigateToProduct(this.product);
    }

    if (quantityEl) {
      this.changeQuantity(quantityEl);
    }

    if (removeEl) {
      this.deleteItem();
    }
  }

  protected getProductPrice() {
    const {selectedCurrencyCode, currenciesList} = this.currencyService;
    const totalPrice = (parseFloat(this.product.price) * this.product.quantity).toFixed(2);

    return CurrencyUtils.getPriceWithSymbolOrCode(totalPrice, selectedCurrencyCode, currenciesList);
  }
}
